import React, { useEffect, useRef, useState } from "react";
import { subYears } from "date-fns/subYears";
import {
  API_ENDPOINTS,
  formatStringKey,
  TERMS,
} from "../../constant/_constant";
import usePostRequest from "../../hooks/usePostRequest";
import { Form, Card, Row, Col, Button, InputGroup } from "react-bootstrap";
import {
  IconFileSearch,
  IconEdit,
  IconCircleDashedCheck,
  IconCreditCard,
} from "@tabler/icons-react";
import useDebounce from "../../hooks/useDebounce";
import moment from "moment";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SuccsessMsgModal from "../../components/SuccessMsgModal";
import ComanConfirmationModal from "../../components/ComanConfirmationModal";
import OtpVerifyPopup from "./OtpVerifyPopup";
import CustomerCardEdit from "./CustomerCardEdit";

const CustomerCardsListing = () => {
  const todayDate = new Date();
  const oneYearAgo = subYears(todayDate, 1);
  const [page, setPage] = useState({
    draft: 1,
    inProgress: 1,
    pending: 1,
    shipped: 1,
    delivered: 1,
    paidclosed: 1,
  });
  const [limit, setLimit] = useState(10);
  const [startDate, setStartDate] = useState(oneYearAgo);
  const [endDate, setEndDate] = useState(todayDate);
  const [draftData, setDraftData] = useState([]);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [search, setSearch] = useState("");
  const [isSearchClicked, setIsSearchClicked] = useState(false);
  const [hasMoreDraft, setHasMoreDraft] = useState(true);
  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const [showCardDetails, setShowCardDetails] = useState(false);
  const [verifiedCardData, setVerifiedCardData] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
    action: null,
    message: "",
  });

  const [isSuccsessModalOpen, setIsSuccsessModalOpen] = useState({
    show: false,
    message: "",
    btntext: "Close",
    title: "Success",
  });

  const user = useSelector((state) => state.auth.user);
  console.log("user from cards", user?.permissions);

  const canEditCards = user?.permissions?.manage_cards?.includes("write");
  const canViewCards = user?.permissions?.manage_cards?.includes("read");

  const navigate = useNavigate();
  const searchInputRef = useRef();
  const tableWrapperRefs = {
    row1: useRef(null),
    row2: useRef(null),
    row3: useRef(null),
    row4: useRef(null),
    row5: useRef(null),
    row6: useRef(null),
  };
  const dropdownRefs = {
    row1: useRef(null),
    row2: useRef(null),
    row3: useRef(null),
    row4: useRef(null),
    row5: useRef(null),
    row6: useRef(null),
  };

  const {
    data: draftres,
    loadingDraft,
    postData: fetchOrderDraft,
  } = usePostRequest(API_ENDPOINTS.GET_CARDS_LISTING);

  const {
    isLoading: Verifying,
    postData: VerifyCustomerOtp,
    data: Verified,
  } = usePostRequest(API_ENDPOINTS.SEND_OTP_CARDS);

  const { debounceSearch } = useDebounce(search);

  const handleSearch = () => {
    const searchValue = searchInputRef.current.value?.trim();
    if ((startDate && !endDate) || (!startDate && endDate)) {
      toast.warning("Please select both the dates.");
      return;
    }
    setPage(() => ({
      draft: 1,
      inProgress: 1,
      pending: 1,
      shipped: 1,
      delivered: 1,
      paidclosed: 1,
    }));
    setSearch(searchValue);
    setIsInitialLoad(false);
    setIsSearchClicked(true);
  };

  // const handleViewClick = (row) => {
  //   setIsViewOpen({
  //     show: true,
  //     order: row,
  //     isStatusUpdate: false,
  //   });
  //   const currentUrl = window.location.pathname;
  //   const newUrl = `${currentUrl}?${row.order_id}`;
  //   window.history.pushState(null, "", newUrl);
  // };

  const handleClearFilter = () => {
    setSearch("");
    setPage(() => ({
      draft: 1,
      inProgress: 1,
      pending: 1,
      shipped: 1,
      delivered: 1,
      paidclosed: 1,
    }));
    setIsInitialLoad(true);
    setIsSearchClicked(true);
  };

  const onSuccessfulFetchOrderDraft = (response, reset = false) => {
    if (response?.data.length < limit) {
      setHasMoreDraft(false);
    }
    setDraftData((prevData) => {
      const combined = reset
        ? response?.data
        : [...prevData, ...response?.data];
      const unique = Array.from(
        new Map(combined.map((item) => [item.invoice_no, item])).values()
      );
      return combined;
    });
  };

  useEffect(() => {
    const isPagination = page.draft > 1;
    const shouldFetch =
      isInitialLoad ||
      isPagination ||
      (isSearchClicked &&
        (selectedStatus.length === 0 || selectedStatus.includes("DRAFT")));
    if (!shouldFetch) return;
    setHasMoreDraft(true);
    fetchOrderDraft(
      {
        page: page.draft,
        limit,
        search: search?.length > 0 ? search : undefined,
      },
      (response) => onSuccessfulFetchOrderDraft(response, page.draft === 1)
    );
    setIsSearchClicked(false);
  }, [page.draft, limit, isSearchClicked]);

  const handleLoadMoreDraft = () => {
    if (hasMoreDraft) {
      setPage((prev) => ({
        ...prev,
        draft: prev.draft + 1,
      }));
    }
  };

  const onSuccessVerify = (res) => {
    console.log("res pf send otp", res);
    toast.success(res?.message);
    // GetPackigSlip({ order_id: orderId });
    setShowOtpPopup(true);
  };

  const onErrorVerify = (err) => {
    toast.error(err?.message || "Failed to delete record");
  };

  const openModal = (id) => {
    let modalMessage =
      "Are you sure you want to edit customer's card details? An OTP will be sent for verification if you proceed.";
    let modalTitle = "Edit Customer Card Details";
    let type = "info";
    let modalIcon = <IconCreditCard />;
    let action = "success";

    const handleSendOtp = () => {
      VerifyCustomerOtp({ id }, onSuccessVerify, onErrorVerify);
      setIsModalOpen({ ...isModalOpen, show: false });
    };

    setIsModalOpen({
      show: true,
      action,
      message: modalMessage,
      onConfirm: handleSendOtp,
      title: modalTitle,
      icon: modalIcon,
      type,
    });
  };

  const handleOtpVerified = (verifiedResponse) => {
    setVerifiedCardData(verifiedResponse);
    setShowOtpPopup(false);
    setShowCardDetails(true);
  };

  return (
    <>
      {showCardDetails && (
        <CustomerCardEdit
          show={showCardDetails}
          onClose={() => setShowCardDetails(false)}
          formData={verifiedCardData}
        />
      )}
      {showOtpPopup && (
        <OtpVerifyPopup
          show={showOtpPopup}
          onClose={() => setShowOtpPopup(false)}
          formData={Verified}
          onVerified={handleOtpVerified}
        />
      )}
      <ComanConfirmationModal
        show={isModalOpen.show}
        onHide={() => setIsModalOpen({ ...isModalOpen, show: false })}
        title={isModalOpen.title}
        message={isModalOpen.message}
        onConfirm={isModalOpen.onConfirm}
        icon={isModalOpen.icon}
        type={isModalOpen.type}
      />
      <SuccsessMsgModal
        show={isSuccsessModalOpen.show}
        onHide={() =>
          setIsSuccsessModalOpen({ ...isSuccsessModalOpen, show: false })
        }
        title={isSuccsessModalOpen?.title}
        btntext={isSuccsessModalOpen?.btntext}
        message={isSuccsessModalOpen?.message}
      />

      <div className="page-header d-print-none">
        <div className="row g-2 align-items-center">
          <div className="col">
            <h2 className="page-title">Payment Cards</h2>
          </div>
        </div>
      </div>

      <Card className="mb-3">
        <Card.Body>
          <Form
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleSearch();
              }
            }}
          >
            <Row>
              <Col lg={6} md={6} className="mb-2">
                <Form.Label className="form-label">Search</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconFileSearch />
                  </InputGroup.Text>
                  <Form.Control
                    ref={searchInputRef}
                    type="text"
                    placeholder="Search..."
                    required
                    name="name"
                    autoComplete="off"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </InputGroup>
              </Col>
              <Col lg={6} md={6} className="mb-2">
                <Form.Label className="form-label">&nbsp;</Form.Label>
                <div className="d-flex gap-2">
                  <Button
                    style={{ minWidth: "auto" }}
                    variant="warning"
                    onClick={handleSearch}
                  >
                    Apply Filters
                  </Button>
                  <Button
                    style={{ minWidth: "auto" }}
                    variant="outline-secondary"
                    onClick={handleClearFilter}
                  >
                    Clear Filters
                  </Button>
                </div>
              </Col>
              <Form.Text>Search by customer email.</Form.Text>
            </Row>
          </Form>
        </Card.Body>
      </Card>

      <div className="order_list_view">
        <div
          className="table-responsive mail_wrapper border-0 p-0"
          ref={tableWrapperRefs.row1}
          style={{ overflowX: "auto" }}
        >
          <table className="table">
            <thead>
              <tr>
                <th>Invoice Number</th>
                <th>Created Date</th>
                <th>Customer Email</th>
                <th>Note</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {draftData.length > 0 ? (
                draftData.map((row, index) => {
                  return (
                    <tr key={index}>
                      <td>{row.invoice_number || "N/A"}</td>
                      <td>
                        {moment(row?.created_at).format("MM/DD/YYYY HH:mm")}
                      </td>
                      <td style={{ textTransform: "lowercase" }}>
                        {row?.customer_email_addresses || "-"}
                      </td>

                      <td>{row?.note || "-"}</td>
                      {/* other tds */}

                      <td style={{ position: "relative" }}>
                        <button
                          onClick={() => openModal(row?.id)}
                          style={{
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                          }}
                          disabled={!canEditCards}
                        >
                          <IconEdit size={20} />
                        </button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="9" className="text-center">
                    No data found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {draftres?.data?.length >= 10 && hasMoreDraft && (
            <div className="text-center mt-3">
              <Button
                variant="outline-primary"
                onClick={handleLoadMoreDraft}
                disabled={loadingDraft}
              >
                {loadingDraft ? "Loading..." : "Load More"}
              </Button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CustomerCardsListing;
